import { useState, useEffect } from "react";
import apiFetch from "../../../../shared/services/apiClient";

/**
 * useInvoices
 *
 * Acepta params con filtros/búsqueda/ordenamiento.
 * Todo se procesa en el backend — el cliente solo recibe las 8 filas de la página.
 * Debounce de 300ms en `search` para no disparar fetch por cada tecla.
 */
export function useInvoices(page = 1, params = {}, refreshKey = 0) {
  const [invoices, setInvoices] = useState([]);
  const [count, setCount] = useState(0);
  const [next, setNext] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const delay = params.search ? 300 : 0;

    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const qs = buildQueryString(page, params);
        const res = await apiFetch(`/api/finance/factura/?${qs}`);
        const data = await res.json();
        if (!cancelled) {
          setInvoices(data.results ?? []);
          setCount(data.count ?? 0);
          setNext(data.next);
          setPrevious(data.previous);
        }
      } catch {
        // errores de red transitorios — silenciar
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, delay);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, refreshKey, JSON.stringify(params)]);

  return { invoices, count, next, previous, loading };
}

function buildQueryString(page, params) {
  const p = new URLSearchParams();
  p.set("page", String(page));

  if (params.search?.trim()) p.set("search", params.search.trim());
  if (params.fecha_desde?.trim())
    p.set("fecha_desde", params.fecha_desde.trim());
  if (params.fecha_hasta?.trim())
    p.set("fecha_hasta", params.fecha_hasta.trim());
  if (params.monto_min?.trim()) p.set("monto_min", params.monto_min.trim());
  if (params.monto_max?.trim()) p.set("monto_max", params.monto_max.trim());
  if (params.ordering?.trim()) p.set("ordering", params.ordering.trim());

  return p.toString();
}
